import { Instance, types } from 'mobx-state-tree';

import { getCuratorGroups } from '@common/api/curators';
import CuratorGroup from '@common/models/CuratorGroups/CuratorGroup';
import TableData from '@common/models/TableData';

const CuratorGroups = types
	.compose(
		TableData,
		types.model({
			data: types.optional(types.array(CuratorGroup), []),
		}),
	)
	.named('CuratorGroups')
	.actions(() => ({
		_fetch: (query: any) => getCuratorGroups(query),
	}));

export default CuratorGroups;

export interface ICuratorGroupsModel extends Instance<typeof CuratorGroups> {}
